import React from 'react';
import { NavLink } from 'react-router-dom';
import './Breadcrumbs.less';

export default function Breadcrumbs(props) {
  const renderItem = (item) => (<li key={item.id}><NavLink to={props.getLink(item)} onClick={() => null}>{item.name}</NavLink></li>);

  return (
    <nav className="breadcrumb">
      <ul>
        {props.items.length > 1 && props.items.map(renderItem)}
      </ul>
    </nav>
  );
}

const getItemsFromNestedObject = (data, parentFieldName = 'parent', passedResult) => {
  const result = passedResult || [];
  if (data[parentFieldName]) getItemsFromNestedObject(data[parentFieldName], parentFieldName, result);
  result.push({ id: data.id, name: data.name, root: !data[parentFieldName] });
  return result;
};

export const BreadcrumbsHelper = {
  getItemsFromNestedObject,
};
